if (!customElements.get('scroll-next-section')) {
  class ScrollNextSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    /**
     * On click handler.
     */
    onClick() {
      this.closest('.shopify-section')?.nextElementSibling?.scrollIntoView();
    }
  }
  customElements.define('scroll-next-section', ScrollNextSection);
}